
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/sentence-rewriter",
      function () {
        return require("private-next-pages/tools/sentence-rewriter.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/sentence-rewriter"])
      });
    }
  